/* ============================================================
   MANSON THEME — Single JS file.
   No external dependencies. No inline scripts in Liquid.
   ============================================================ */

'use strict';

/* ── Tab title on blur ── */
(function () {
  var orig = document.title;
  document.addEventListener('visibilitychange', function () {
    document.title = document.hidden ? 'still here.' : orig;
  });
})();

/* ── Right-click suppress ── */
document.addEventListener('contextmenu', function (e) { e.preventDefault(); });

/* ── Cart drawer ── */
var CartDrawer = (function () {
  var drawer, overlay, itemsEl, totalEl, closeBtn;
  var _cache = null;

  function init() {
    drawer   = document.getElementById('CartDrawer');
    overlay  = document.getElementById('CartDrawerOverlay');
    itemsEl  = document.getElementById('CartDrawerItems');
    totalEl  = document.getElementById('CartDrawerTotal');
    closeBtn = document.getElementById('CartDrawerClose');

    if (!drawer) return;

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-open-cart]');
      if (t) { e.preventDefault(); open(); }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeBtn.classList.add('spinning');
        setTimeout(function () { closeBtn.classList.remove('spinning'); }, 340);
        close();
      });
    }

    if (overlay) overlay.addEventListener('click', close);

    document.addEventListener('click', function (e) {
      var rem = e.target.closest('[data-remove-item]');
      if (rem) removeItem(rem.dataset.removeItem, rem);
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (btn) changeQty(btn);
    });

    document.addEventListener('submit', function (e) {
      if (!e.target.closest('[data-add-to-cart-form]')) return;
      e.preventDefault();
      addToCart(e.target);
    });
  }

  function open() {
    openDrawer();
    if (_cache) render(_cache);
    refresh();
  }

  function close() {
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  function refresh(cb) {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        if (cb) cb();
      })
      .catch(function (err) { console.error('Cart refresh error:', err); });
  }

  function render(cart) {
    _cache = cart;
    var count = cart.item_count;
    var countEl = document.getElementById('CartCount');
    if (countEl) countEl.textContent = count;
    var mobileCountEl = document.getElementById('MobileCartCount');
    if (mobileCountEl) mobileCountEl.textContent = count;

    if (!itemsEl) return;

    if (count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer-empty"><p>You should definitely put stuff in your cart.</p></div>';
      if (totalEl) totalEl.textContent = '';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var linePrice = item.final_line_price / 100;
      var comparePrice = item.original_line_price / 100;
      var onSale = item.final_line_price < item.original_line_price;
      var priceStr = onSale
        ? '<span class="cart-drawer-item__final-price-on-sale">' + fmt(linePrice) + '</span>' +
          '<span class="cart-drawer-item__compare-price"><s>' + fmt(comparePrice) + '</s></span>'
        : '<span class="cart-drawer-item__final-price">' + fmt(linePrice) + '</span>';

      html += '<div class="cart-drawer-item">' +
        '<div class="cart-drawer-item__img-cont">' +
        (item.image ? '<img class="cart-drawer-item__img" src="' + item.image + '" alt="' + esc(item.title) + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="cart-drawer-item__details">' +
        '<h3 class="cart-drawer-item__title">' + esc(item.product_title) + '</h3>' +
        (item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="cart-drawer-item__variant">' + esc(item.variant_title) + '</p>' : '') +
        '<div class="cart-drawer-item__quantity">' +
        '<div class="quantity-wrapper-drawer">' +
        '<button class="cart-drawer__quantity-btn cart-drawer__quantity-btn-minus' +
          (item.quantity <= 1 ? ' disabled' : '') + '"' +
          ' data-qty-change data-key="' + item.key + '" data-delta="-1"' +
          (item.quantity <= 1 ? ' disabled' : '') + '>' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 7.5h12v1H2z"/></svg>' +
        '</button>' +
        '<span class="cart-drawer__quantity-value">' + item.quantity + '</span>' +
        '<button class="cart-drawer__quantity-btn cart-drawer__quantity-btn-plus" data-qty-change data-key="' + item.key + '" data-delta="1">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8.5 2v5.5H14v1H8.5V14h-1V8.5H2v-1h5.5V2z"/></svg>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '<div class="cart-drawer-item__price">' + priceStr + '</div>' +
        '<button class="cart-drawer-item__remove-link" data-remove-item="' + item.key + '" type="button">' +
          (window.cartStrings && window.cartStrings.remove ? window.cartStrings.remove : 'Remove') +
        '</button>' +
        '</div>' +
        '</div>';
    });

    itemsEl.innerHTML = html;

    if (totalEl) {
      totalEl.textContent = (window.cartStrings && window.cartStrings.total ? window.cartStrings.total : 'Total') +
        ': ' + fmt(cart.total_price / 100);
    }
  }

  function fmt(n) {
    var str = n.toFixed(2).replace(/\.00$/, '');
    return str + ' USD';
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function removeItem(key, el) {
    var item = el && el.closest('.cart-drawer-item');
    if (item) item.style.opacity = '0.4';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(console.error);
  }

  var qtyTimers = {};
  function changeQty(btn) {
    if (btn.disabled) return;
    var key   = btn.dataset.key;
    var delta = parseInt(btn.dataset.delta, 10);
    var valEl = btn.parentElement.querySelector('.cart-drawer__quantity-value');
    var cur   = parseInt(valEl ? valEl.textContent : '1', 10);
    var next  = Math.max(0, cur + delta);
    if (valEl) valEl.textContent = next;
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); })
        .catch(console.error);
    }, 300);
  }

  function shakeSizes(form) {
    var optionValues = form && form.querySelector('.option-values');
    if (!optionValues) return;
    optionValues.classList.remove('instacop-shake');
    void optionValues.offsetWidth;
    optionValues.classList.add('instacop-shake');
    setTimeout(function () { optionValues.classList.remove('instacop-shake'); }, 400);
  }

  function flash(btn, text) {
    if (!btn) return;
    var orig = btn.textContent;
    btn.textContent = text;
    btn.disabled = true;
    setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800);
  }

  // Shared add: posts one variant, opens the drawer on success, flashes the button on failure
  function add(id, btn) {
    if (btn) btn.disabled = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        if (btn) btn.disabled = false;
        openDrawer();
        if (_cache) render(_cache);
        refresh();
      })
      .catch(function () { flash(btn, 'JUST SOLD OUT'); });
  }

  function addToCart(form) {
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('[data-add-btn]');
    if (!idInput || !idInput.value) { shakeSizes(form); return; }
    add(idInput.value, btn);
  }

  function openDrawer() {
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  return { init: init, open: open, close: close, refresh: refresh, add: add, shakeSizes: shakeSizes };
})();

/* ── Product card — swipe + hover cycle ── */
var ProductCards = (function () {
  function init() {
    initCards(document.querySelectorAll('[data-product-card]'));
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('[data-product-card]')) initCards([node]);
          node.querySelectorAll && node.querySelectorAll('[data-product-card]').forEach(function (c) {
            initCards([c]);
          });
        });
      });
    });
    var grid = document.getElementById('product-list');
    if (grid) observer.observe(grid, { childList: true, subtree: true });
  }

  function initCards(cards) {
    cards.forEach(function (card) {
      if (card._mansonInit) return;
      card._mansonInit = true;

      var imgs   = card.querySelectorAll('.product-card__image');
      var prevBtn = card.querySelector('.product-card-arrow--prev');
      var nextBtn = card.querySelector('.product-card-arrow--next');
      var cur = 0;

      if (imgs.length < 2) return;

      function show(idx) {
        imgs[cur].classList.remove('is-active');
        cur = (idx + imgs.length) % imgs.length;
        imgs[cur].classList.add('is-active');
      }

      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); show(cur - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); show(cur + 1); });

    });
  }

  return { init: init };
})();

/* ── Product card quick add (desktop only; hidden by CSS on touch) ── */
var QuickAdd = (function () {
  // Colour swatch: show that colour's sizes and swap the visible card image to it
  function pickColor(sw) {
    var card = sw.closest('.product-list__product-block, .hc-item');
    if (!card) return;
    var color = sw.getAttribute('data-qa-swatch');
    card.querySelectorAll('[data-qa-swatch]').forEach(function (s) { s.classList.toggle('is-active', s === sw); });
    card.querySelectorAll('[data-qa-color]').forEach(function (b) { b.hidden = b.getAttribute('data-qa-color') !== color; });
    var img = sw.getAttribute('data-qa-img');
    if (!img) return;
    // First image = colour's flat, second = the shot after it, so hover still cycles
    var hover = sw.getAttribute('data-qa-hover') || img;
    var cardImgs = card.querySelectorAll('.product-card__image');
    if (cardImgs.length) {
      cardImgs.forEach(function (el, i) {
        if (i > 1) return;
        el.removeAttribute('srcset');
        el.src = i === 0 ? img : hover;
      });
    }
    card.querySelectorAll('.hc-img-default, .hc-img-hover').forEach(function (el) {
      el.removeAttribute('srcset');
      el.src = el.classList.contains('hc-img-hover') ? hover : img;
    });
  }

  function init() {
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-qa-swatch]');
      if (sw) { e.preventDefault(); e.stopPropagation(); pickColor(sw); return; }

      var btn = e.target.closest('[data-quick-add-id]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      CartDrawer.add(btn.getAttribute('data-quick-add-id'), btn);
    });
  }
  return { init: init };
})();

/* ── Desktop nav — submenu toggle ── */
var DesktopNav = (function () {
  function init() {
    document.addEventListener('click', function (e) {
      var item = e.target.closest('.manson-nav-item[data-has-submenu]');
      if (item) {
        e.preventDefault();
        var isOpen = item.classList.contains('open');
        document.querySelectorAll('.manson-nav-item.open').forEach(function (i) {
          i.classList.remove('open');
        });
        if (!isOpen) item.classList.add('open');
      } else {
        document.querySelectorAll('.manson-nav-item.open').forEach(function (i) {
          i.classList.remove('open');
        });
      }
    });
  }
  return { init: init };
})();

/* ── Mobile nav toggle ── */
var MobileNav = (function () {
  function init() {
    var toggleBtn = document.getElementById('MobileMenuToggle');
    var overlay   = document.getElementById('MobileNavLinks');
    var closeBtn  = document.getElementById('MobileNavClose');

    if (!toggleBtn || !overlay) return;

    // Menu drops down under the bar; the MENU button flips to CLOSE
    function setOpen(open) {
      overlay.classList.toggle('open', open);
      document.body.classList.toggle('menu-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      toggleBtn.textContent = open ? 'CLOSE' : 'MENU';
      toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    toggleBtn.addEventListener('click', function () {
      setOpen(!overlay.classList.contains('open'));
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
  }
  return { init: init };
})();

/* ── Collection column switcher ── */
var ColSwitcher = (function () {
  function init() {
    var btns = document.querySelectorAll('.col-switcher__btn');
    var grid = document.getElementById('product-list');
    if (!btns.length || !grid) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.dataset.cols;
        grid.dataset.cols = cols;
        btns.forEach(function (b) { b.classList.toggle('is-active', b.dataset.cols === cols); });
        try { localStorage.setItem('manson_grid_cols', cols); } catch (e) {}
      });
    });

    /* Restore */
    try {
      var saved = localStorage.getItem('manson_grid_cols');
      if (saved) {
        grid.dataset.cols = saved;
        btns.forEach(function (b) { b.classList.toggle('is-active', b.dataset.cols === saved); });
      }
    } catch (e) {}
  }
  return { init: init };
})();

/* ── Fit toggle (MASC / FEMME) — FLIP sort animation ── */
var FitToggle = (function () {
  var current = null;
  var root, grid, btns;
  var run = 0;          /* bumps on every new animation; stale chains bail out */
  var busy = false;
  var pending = false;  /* cards arrived from infinite scroll mid-animation */
  var EASE = 'cubic-bezier(0.65, 0, 0.35, 1)';

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function matches(card, fit) {
    return !fit || (' ' + (card.dataset.fit || 'masc') + ' ').indexOf(' ' + fit + ' ') !== -1;
  }

  function cards() {
    return Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));
  }

  function inView(rect) {
    return rect.bottom > -100 && rect.top < window.innerHeight + 100;
  }

  /* The theme's CSS load-in (.fade-in) restarts whenever a card leaves display:none.
     Once the grid is being filtered, cards get their final state and only WAAPI moves them. */
  function settle(list) {
    list.forEach(function (c) { c.classList.add('is-fit-settled'); });
  }

  function stopAll() {
    cards().forEach(function (c) {
      c.getAnimations().forEach(function (a) { a.cancel(); });
    });
  }

  function moveSlab() {
    var active = root.querySelector('.fit-toggle__btn.is-active');
    root.classList.toggle('has-active', !!active);
    if (active) {
      root.style.setProperty('--slab-x', active.offsetLeft + 'px');
      root.style.setProperty('--slab-w', active.offsetWidth + 'px');
    }
  }

  function setButtons() {
    btns.forEach(function (b) {
      var on = b.dataset.fit === current;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    moveSlab();
  }

  /* Pinned pieces (skirts) lead the FEMME view; everything else keeps collection order */
  function setOrder(fit) {
    if (fit) grid.dataset.fitActive = fit; else delete grid.dataset.fitActive;
  }

  /* Instant — used on load and under reduced motion */
  function apply() {
    if (!grid) return;
    setOrder(current);
    cards().forEach(function (c) { c.classList.toggle('is-fit-hidden', !matches(c, current)); });
  }

  function animateTo(fit) {
    var all = cards();
    if (reduced() || !all[0] || !all[0].animate) { apply(); return; }

    var id = ++run;
    busy = true;
    stopAll();
    settle(all);

    var leaving = all.filter(function (c) { return !c.classList.contains('is-fit-hidden') && !matches(c, fit); });
    var staying = all.filter(function (c) { return !c.classList.contains('is-fit-hidden') && matches(c, fit); });
    var entering = all.filter(function (c) { return c.classList.contains('is-fit-hidden') && matches(c, fit); });

    /* 1. Visible leaving cards drop out, staggered */
    var outAnims = leaving
      .filter(function (c) { return inView(c.getBoundingClientRect()); })
      .slice(0, 12)
      .map(function (c, i) {
        return c.animate(
          [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(12px) scale(0.94)' }],
          { duration: 220, delay: i * 25, easing: EASE, fill: 'forwards' }
        ).finished;
      });

    Promise.all(outAnims).catch(function () {}).then(function () {
      if (id !== run) return;

      /* 2. Swap layout, then FLIP the survivors from where they were */
      var first = staying.map(function (c) { return c.getBoundingClientRect(); });
      leaving.forEach(function (c) { c.classList.add('is-fit-hidden'); });
      entering.forEach(function (c) { c.classList.remove('is-fit-hidden'); });
      setOrder(fit);
      stopAll();

      var moves = [];
      staying.forEach(function (c, i) {
        var last = c.getBoundingClientRect();
        var dx = first[i].left - last.left, dy = first[i].top - last.top;
        if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
        if (!inView(last) && !inView(first[i])) return;
        moves.push(c.animate(
          [{ transform: 'translate3d(' + dx + 'px,' + dy + 'px,0)' }, { transform: 'none' }],
          { duration: 480, easing: EASE }
        ).finished);
      });

      /* 3. Entering cards rise in, staggered */
      var n = 0;
      entering.forEach(function (c) {
        if (!inView(c.getBoundingClientRect())) return;
        moves.push(c.animate(
          [{ opacity: 0, transform: 'translate3d(0,20px,0)' }, { opacity: 1, transform: 'none' }],
          { duration: 420, delay: 100 + Math.min(n++, 8) * 40, easing: EASE, fill: 'backwards' }
        ).finished);
      });

      return Promise.all(moves);
    }).catch(function () {}).then(function () {
      if (id !== run) return;
      busy = false;
      if (pending) { pending = false; animateTo(current); }
    });
  }

  /* Cards appended by infinite scroll */
  function added(list) {
    if (!grid || !current) return;
    settle(list);
    list.forEach(function (c) { c.classList.add('is-fit-hidden'); });
    if (busy) pending = true; else animateTo(current);
  }

  function select(fit) {
    current = current === fit ? null : fit; /* tap the active one again to show all */
    setButtons();
    animateTo(current);
    if (current && typeof InfScroll !== 'undefined') InfScroll.loadAll();
    try {
      var url = new URL(window.location.href);
      if (current) url.searchParams.set('fit', current); else url.searchParams.delete('fit');
      history.replaceState(null, '', url);
    } catch (e) {}
  }

  function init() {
    root = document.querySelector('[data-fit-toggle]');
    grid = document.getElementById('product-list');
    if (!root || !grid) return;
    btns = Array.prototype.slice.call(root.querySelectorAll('.fit-toggle__btn'));

    btns.forEach(function (b) {
      b.addEventListener('click', function () { select(b.dataset.fit); });
    });

    try {
      var p = new URL(window.location.href).searchParams.get('fit');
      if (p === 'masc' || p === 'femme') current = p;
    } catch (e) {}

    setButtons();
    apply();
    if (current && typeof InfScroll !== 'undefined') setTimeout(InfScroll.loadAll, 0);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(moveSlab);
    window.addEventListener('resize', moveSlab);
  }

  function active() { return !!current; }

  return { init: init, apply: apply, added: added, active: active };
})();

/* ── Infinite scroll ── */
var InfScroll = (function () {
  var loading = false;
  var nextUrl = null;

  function init() {
    var grid = document.getElementById('product-list');
    if (!grid) return;
    nextUrl = grid.dataset.nextUrl || null;
    if (!nextUrl) return;

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function onScroll() {
    if (loading || !nextUrl) return;
    var scrollBottom = window.scrollY + window.innerHeight;
    if (scrollBottom >= document.body.scrollHeight - 600) loadMore();
  }

  function loadMore() {
    loading = true;
    var grid = document.getElementById('product-list');
    fetch(nextUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc    = parser.parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-list');
        if (newGrid) {
          var added = Array.from(newGrid.children);
          added.forEach(function (child) {
            grid.appendChild(child);
          });
          nextUrl = (newGrid.dataset.nextUrl) || null;
          ProductCards.init();
          FitToggle.added(added.filter(function (c) { return c.matches('[data-product-card]'); }));
          stripZeroCents();
        } else {
          nextUrl = null;
        }
        loading = false;
        if (nextUrl && FitToggle.active()) loadMore();
      })
      .catch(function () { loading = false; });
  }

  function loadAll() {
    if (!loading && nextUrl) loadMore();
  }

  return { init: init, loadAll: loadAll };
})();

/* ── Enter page ── */
var EnterPage = (function () {
  function dismiss() {
    document.documentElement.classList.add('manson-entered');
  }

  function init() {
    var section = document.getElementById('shopify-section-enterpage');
    if (!section) return;

    /* Don't hide the overlay on navigating clicks: on mobile it sits in flow,
       so hiding it lets the grid jump up before the next page paints. */
    section.addEventListener('click', function (e) {
      var link = e.target.closest('.enter-menu-link');
      if (!link) return;
      e.preventDefault();
      var href = link.getAttribute('href');
      if (href && href !== '#') window.location.href = href;
    });
  }

  return { init: init };
})();

/* ── Size chart modal ── */
var SizeChart = (function () {
  function init() {
    var modal = document.getElementById('sc-modal');
    if (!modal) return;

    document.addEventListener('click', function (e) {
      if (e.target.closest('.sc-trigger') || e.target.closest('.sc-trigger-mobile')) {
        modal.style.display = 'flex';
      }
      if (e.target.closest('#sc-close') || e.target === modal) {
        modal.style.display = 'none';
      }
      var unitBtn = e.target.closest('.sc-unit-btn');
      if (unitBtn) {
        var unit = unitBtn.dataset.unit;
        var panel = unitBtn.closest('.sc-modal-box') || document;
        panel.querySelectorAll('.sc-unit-btn').forEach(function (b) {
          b.classList.toggle('active', b.dataset.unit === unit);
        });
        panel.querySelectorAll('[data-unit-row]').forEach(function (row) {
          row.style.display = row.dataset.unitRow === unit ? '' : 'none';
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') modal.style.display = 'none';
    });
  }
  return { init: init };
})();

/* ── COP RN — instant checkout ── */
var Instacop = (function () {
  function init() {
    var btn = document.querySelector('[data-instacop]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var form = btn.closest('form');
      var idInput = form && form.querySelector('input[name="id"]');
      var variantId = idInput && idInput.value;
      if (!variantId) { CartDrawer.shakeSizes(form); return; }
      btn.disabled = true;
      btn.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'COP RN';
      });
    });
  }
  return { init: init };
})();

/* ── Product page mobile image nav ── */
var ProductImageNav = (function () {
  function init() {
    var nav = document.querySelector('.image-navigation');
    if (!nav) return;
    var figure    = document.querySelector('.figureImg');
    if (!figure) return;
    var imgs      = figure.querySelectorAll('.product__item-img, .product__item-video');
    var dots      = nav.querySelectorAll('.nav-dot');
    var prevArrow = nav.querySelector('.nav-arrow--prev');
    var nextArrow = nav.querySelector('.nav-arrow--next');
    var cur = 0;

    function goTo(idx) {
      cur = Math.max(0, Math.min(imgs.length - 1, idx));
      imgs[cur].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      dots.forEach(function (d, i) { d.classList.toggle('active', i === cur); });
    }

    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });
    if (prevArrow) prevArrow.addEventListener('click', function () { goTo(cur - 1); });
    if (nextArrow) nextArrow.addEventListener('click', function () { goTo(cur + 1); });

    /* Scroll spy */
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = Array.from(imgs).indexOf(entry.target);
          if (idx >= 0) {
            cur = idx;
            dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
          }
        }
      });
    }, { root: figure, threshold: 0.5 });

    imgs.forEach(function (img) { observer.observe(img); });
  }
  return { init: init };
})();

/* ── Footer big logo ── */
var FooterLogo = (function () {
  function init() {
    var img = document.querySelector('.manson-footer-big-logo');
    if (!img) return;
    function fit() { img.style.width = document.body.clientWidth + 'px'; }
    fit();
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(fit, 100);
    });
  }
  return { init: init };
})();

/* ── Drop countdown ── */
var DropCountdown = (function () {
  function init() {
    var el = document.querySelector('.product-card-countdown');
    if (!el) return;
    var target = new Date(el.dataset.dropTarget).getTime();
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { el.textContent = 'DROPPING NOW'; return; }
      el.querySelector('.pcc-days').textContent  = String(Math.floor(diff / 86400000)).padStart(2, '0');
      el.querySelector('.pcc-hours').textContent = String(Math.floor((diff % 86400000) / 3600000)).padStart(2, '0');
      el.querySelector('.pcc-mins').textContent  = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
      el.querySelector('.pcc-secs').textContent  = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  }
  return { init: init };
})();

/* ── Custom cursor — injected inline in theme.liquid for zero-delay load ── */
var Cursor = (function () {
  function init() {}
  return { init: init };
})();

/* ── Product cards: fade + rise as they scroll into view, staggered per batch ── */
var Reveal = (function () {
  function init() {
    if (!document.documentElement.classList.contains('js-reveal')) return;
    window.__mansonReveal = true;
    var io = new IntersectionObserver(function (entries) {
      var order = 0;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.style.setProperty('--reveal-order', order++);
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    /* Cards already on screen stay put (the page crossfade is their entrance);
       only cards further down get hidden and rise in as they scroll into view. */
    function watch(root) {
      root.querySelectorAll('[data-product-card]:not([data-reveal-seen])').forEach(function (c) {
        c.setAttribute('data-reveal-seen', '');
        if (c.getBoundingClientRect().top < window.innerHeight * 0.92) return;
        c.classList.add('is-reveal-pending');
        io.observe(c);
      });
    }
    watch(document);
    /* infinite scroll appends more cards */
    new MutationObserver(function () { watch(document); })
      .observe(document.body, { childList: true, subtree: true });
  }
  return { init: init };
})();

/* ── Boot ── */
document.addEventListener('DOMContentLoaded', function () {
  DropCountdown.init();
  Cursor.init();
  CartDrawer.init();
  ProductCards.init();
  QuickAdd.init();
  DesktopNav.init();
  MobileNav.init();
  ColSwitcher.init();
  FitToggle.init();
  InfScroll.init();
  EnterPage.init();
  SizeChart.init();
  Instacop.init();
  ProductImageNav.init();
  FooterLogo.init();
  Reveal.init();
});

